module.exports = __webpack_public_path__ + "media/images/logos/app-logo-white-pink-plinth-b139f05238457cba5e5f91871d2bee71.svg";